import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import vi from './vi';
import en from './en';

// Khởi tạo i18n với cấu hình tối ưu
i18n
  .use(initReactI18next)
  .init({
    resources: {
      vi: { translation: vi },
      en: { translation: en }
    },
    lng: 'vi',
    fallbackLng: 'vi',
    debug: false, // Tắt debug trong production
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span', 'div'],
    }
  });

// Hàm thay đổi ngôn ngữ
export const changeLanguage = (language) => {
  i18n.changeLanguage(language);
  localStorage.setItem('i18nextLng', language);
};

// Hàm lấy ngôn ngữ hiện tại
export const getCurrentLanguage = () => i18n.language;

// Hàm lấy danh sách ngôn ngữ hỗ trợ
export const getSupportedLanguages = () => [
  { code: 'vi' },
  { code: 'en' }
];

// Hàm kiểm tra ngôn ngữ có được hỗ trợ không
export const isLanguageSupported = (language) => ['vi', 'en'].includes(language);

export default i18n;
